// External URLs
export const EXTERNAL_URLS = {
    CV_DOCUMENT: "https://docs.google.com/document/d/1nKTYS6Kpbudj4OrKxVRiX51Bv75g_WiLrREEeJjCEqQ/edit?usp=sharing",
    WHATSAPP: "https://wa.me/+2348167976085",
    TWITTER: "https://twitter.com/izimartinz/",
    FACEBOOK: "https://web.facebook.com/Izimartinz/",
    INSTAGRAM: "https://instagram.com/izimartin/",
    GITHUB: "https://github.com/izimartin/",
    LINKEDIN: "https://www.linkedin.com/in/izimartin/",
};

// Navigation items
export const NAVIGATION_ITEMS = [
    { name: "About", href: "#Hero" },
    { name: "Services", href: "#Services" },
    { name: "Portfolio", href: "#Portfolio" },
    { name: "Testimonials", href: "#Testimonials" },
    { name: "Contact", href: "#Contact" },
];

// Social media links
export const SOCIAL_LINKS = [
    {
        name: "Twitter",
        href: EXTERNAL_URLS.TWITTER,
        icon: "FaTwitter",
        hoverColor: "hover:text-blue-500",
    },
    {
        name: "Facebook",
        href: EXTERNAL_URLS.FACEBOOK,
        icon: "FaFacebook",
        hoverColor: "hover:text-blue-500",
    },
    {
        name: "Instagram",
        href: EXTERNAL_URLS.INSTAGRAM,
        icon: "FaInstagram",
        hoverColor: "hover:text-pink-500",
    },
    {
        name: "GitHub",
        href: EXTERNAL_URLS.GITHUB,
        icon: "FaGithub",
        hoverColor: "hover:text-gray-900",
    },
    {
        name: "LinkedIn",
        href: EXTERNAL_URLS.LINKEDIN,
        icon: "FaLinkedin",
        hoverColor: "hover:text-blue-600",
    },
];

// Services data
export const SERVICES = [
    {
        id: 1,
        number: "01",
        title: "Website Development",
        description: "I specialize in creating high-quality websites that are optimized for speed, security, and user experience. Whether you need a simple brochure website or a complex web application, I can help you create a website that meets your specific needs.",
    },
    {
        id: 2,
        number: "02",
        title: "Mobile App Development",
        description: "I can help you create a mobile app that will help you reach more customers and engage with them in new ways. From design to development to launch, I can help you create a mobile app that will help you grow your business.",
    },
    {
        id: 3,
        number: "03",
        title: "Software Consulting",
        description: "I offer software consulting services to help you evaluate your current software infrastructure and identify areas for improvement. Whether you need help with software architecture, performance optimization, or security, I can help you make the right decisions to achieve your goals.",
    },
];

// Personal information
export const PERSONAL_INFO = {
    NAME: "Martins",
    FULL_NAME: "Martins Akhivbareme",
    TITLE: "SOFTWARE ENGINEER",
    DESCRIPTION: "I craft highly-performing websites, mobile apps and webapps that are conversion-focused, brand-accurate and people friendly.",
    AVATAR_URL: "https://avatars.githubusercontent.com/u/39589537?v=4",
    CV_FILENAME: "Martins Akhivbareme's Resume.pdf",
};

// Button text
export const BUTTON_TEXT = {
    LETS_TALK: "LET'S TALK",
    DOWNLOAD_CV: "Download CV",
    GET_IN_TOUCH: "GET IN TOUCH",
    START_CONVERSATION: "START A CONVERSATION",
    FOLLOW_ME: "Follow me:",
};
